<template>
  <div v-loading="loading" element-loading-text="跳转中..."></div>
</template>

<script>
export default {
  name: 'login-auto',
  data () {
    return {
      loading: true,
      token: '',
      targetUri: ''
    }
  },
  created () {
    this.token = this.getUrlParam('token')
    this.targetUri = this.getUrlParam('targetUri') || '/home'
    this.autoLogin()
  },
  methods: {
    // 自动登录
    autoLogin () {
      this.$store.dispatch('autoLogin', { token: this.token }).then(res => {
        if (res.data.resultCode === '0') {
          this.$store.commit('SET_USER_INFO', res.data.resultData)
          this.$router.push(this.targetUri)
        } else {
          setTimeout(() => {
            location.replace('/login')
          }, 3000)
        }
      }).catch((err) => {
        if (err.response.status !== '401') {
          setTimeout(() => {
            location.replace('/login')
          }, 3000)
        }
      })
    },

    // 获取url参数
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var url = decodeURI(window.location.search)
      var r = url.substr(1).match(reg)
      if (r !== null) {
        return unescape(r[2])
      }
      return null
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'login') {
      this.$store.commit('setTargetUri', this.targetUri)
    } else {
      this.$store.commit('setTargetUri', '')
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
div {
  text-align: center;
  padding-top: 200px;
  font-size: 20px;
}
</style>
